// src/pages/ServiceRow.js

import React from 'react';
import { TableRow, TableCell, IconButton } from '@mui/material';
import { ArrowForwardIos as ArrowForwardIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import CommentsMenu from '../components/CommentsMenu';
import { formatDate, formatTime } from '../utils/dateTimeUtils';
import ImageGalleryDropdown from '../components/ImageGalleryDropdown';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';

function ServiceRow({ service, columns, services }) {

    const showCustomer = columns?.some(col => col.id === 'customer');
    const showPet = columns?.some(col => col.id === 'pet');
    const showGroomer = columns?.some(col => col.id === 'groomer');
    const images = service.bucket?.images || [];
    // Use optional chaining to safely access pet and owner properties
    const ownerName = service.pet?.owner
        ? `${service.pet.owner.firstName} ${service.pet.owner.lastName}`
        : 'No Customer';

    const petName = service.pet?.name || 'No Pet';
    const groomerName = service.groomer
        ? `${service.groomer.firstName} ${service.groomer.lastName}`
        : 'No Groomer';

    return (
        <TableRow>
            {/* Redirect Icon */}
            <TableCell>
                <IconButton
                    component={Link}
                    to={`/services/${service.id}`}
                    state={{ records: services }}
                    aria-label="view-details"
                >
                    <ArrowForwardIcon sx={{ fontSize: 'small' }} />
                </IconButton>
            </TableCell>
            <TableCell>{formatDate(service.date)}</TableCell>
            <TableCell>{formatTime(service.time)}</TableCell>
            <TableCell>{service.service}</TableCell>
            <TableCell>{service.amount}</TableCell>
            {showCustomer && <TableCell>{ownerName}</TableCell>}
            {showPet && <TableCell>{petName}</TableCell>}
            {showGroomer && <TableCell>{groomerName}</TableCell>}
            <TableCell>
                <CommentsMenu comments={service.comments} />
            </TableCell>
            <TableCell>
                {images.length > 1 ? (
                    <ImageGalleryDropdown
                        images={images}
                        onUploadSuccess={null}
                        onDelete={null}
                        serviceId={service.id}
                        readOnly={true}
                    />
                ) : images.length === 1 ? (
                    <a href={images[0].imageUrl} target="_blank" rel="noopener noreferrer">
                        <IconButton aria-label="view image">
                            <PhotoLibraryIcon sx={{ fontSize: '18px', color: 'primary.main' }} />
                        </IconButton>
                    </a>
                ) : null}
            </TableCell>
        </TableRow>
    );
}

export default ServiceRow;